import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { AuthGetSession } from '@src/auth/auth-client';

interface UseIsLoggedInResult {
	isLoggedIn: boolean;
	isExpired: boolean;
	token: string | null;
	tokenExpiry: string | null;
	checked: boolean;
}

const useIsLoggedIn = (): UseIsLoggedInResult => {
	const router = useRouter();
	const [token, setToken] = useState<string | null>(null);
	const [tokenExpiry, setTokenExpiry] = useState<string | null>(null);
	const [isExpired, setIsExpired] = useState<boolean>(true);
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
	const [checked, setChecked] = useState<boolean>(false);

	useEffect(() => {
		const { storedToken, storedTokenExpiry } = AuthGetSession();

		setToken(storedToken);
		setTokenExpiry(storedTokenExpiry);

		if (storedTokenExpiry) {
			const expiryTime = Number(storedTokenExpiry);
			setIsExpired(Date.now() > expiryTime);
		} else {
			setIsExpired(true);
		}

		setIsLoggedIn(Boolean(storedToken && storedTokenExpiry && Date.now() < Number(storedTokenExpiry)));
		setChecked(true);
	}, [router.pathname]);

	return { isExpired, isLoggedIn, token, tokenExpiry, checked };
};

export default useIsLoggedIn;
